import React from 'react'
import Utils from '../../Utils';
import classes from './LinkButton.module.css';

function LinkButton({ className, onClick, style, label, disabled, children }) {
    return <div className={Utils.getClasses(classes.main, className, disabled && classes.disabled)} onClick={onClick} style={style}>
        {children || label}
    </div>
}

export default LinkButton;